import { Link } from 'react-router-dom';
import { buttonClasses } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-gray-900">Page not found</h1>
      <p className="text-sm text-gray-500">The page you are looking for does not exist.</p>
      <Link to="/" className={buttonClasses()}>
        Back to dashboard
      </Link>
    </div>
  );
}
